import React, { useState, useEffect } from "react";
import { Grid, Card, Tabs, Tab, Box, TextField, Button, Backdrop, CircularProgress, Autocomplete, Tooltip } from "@mui/material";
import { Edit } from '@mui/icons-material'; // Import Material-UI Edit Icon
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { url } from "../../constant";
// Your component
import { iconOptions } from "./materialIcons";

function PlatformFeatureDashboard() {
  const [tab, setTab] = useState(0);
  const [platformHeading, setPlatformHeading] = useState("");
  const [items, setItems] = useState([
    { id: 1, title: "Real-Time Notifications", description: "Instant alerts for new tenders", icon: "notifications" },
    { id: 2, title: "Smart Matching", description: "Intelligent tender recommendations", icon: "smart_toy" },
    { id: 3, title: "Central Dashboard", description: "Manage everything in one place", icon: "dashboard" },
  ]);

  const [formState, setFormState] = useState({ title: "", description: "", icon: "" });
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // Toggle edit mode for platform heading
  const [isEditingHeading, setIsEditingHeading] = useState(false);

  useEffect(() => {
    fetchHeading();
    fetchPlatformFeatures();
  }, []);

  const fetchPlatformFeatures = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${url}auth/get-platform-features`);
      if (!response.ok) throw new Error("Errore durante il recupero delle funzionalità");

      const data = await response.json();

      console.log("getPlatformFeatures", data);

      setItems(data); // Update the state with fetched data
    } catch (error) {
      console.error("Fetch error:", error.message);
      alert("Errore nel caricamento delle funzionalità della piattaforma");
    } finally {
      setLoading(false);
    }
  };

  // Heading fetch karne ke liye
  const fetchHeading = () => {
    fetch(`${url}auth/platform-heading`)  // backend ka endpoint
      .then((res) => res.json())
      .then((data) => {

        setPlatformHeading(data.data || "Default Heading");
        console.log("/platform-heading", data);

      })
      .catch((err) => console.error("Failed to fetch heading:", err));
  };

  const handleSaveHeading = () => {
    // Save the new heading to the backend
    fetch(`${url}auth/platform-heading`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title: platformHeading }),
    })
      .then((res) => res.json())
      .then((data) => {
        // setPlatformHeading(data.data); // Update the heading in state
        fetchHeading();
        setIsEditingHeading(false); // Exit edit mode
      })
      .catch((err) => {
        console.log("Failed to save heading:", err);
      });
  };


  const handleEditHeading = () => {
    setIsEditingHeading(true);
  };

  const handleCancelEdit = () => {
    fetchHeading();
    setIsEditingHeading(false); // Close the edit mode without saving
  };

  // // List of Material Icons (you can expand this)
  // const iconOptions = [
  //   "dashboard",
  //   "notifications",
  //   "smart_toy",
  //   "analytics",
  //   "search",
  //   "account_circle",
  //   "settings",
  //   "help",
  //   "check_circle",
  //   "info",
  //   "lock",
  //   "visibility",
  //   "email",
  // ];

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Title", accessor: "title" },
    // { Header: "Description", accessor: "description" },
    {
      Header: "Description",
      accessor: "description",
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 350,
            }}
          >
            {value}
          </div>
        </Tooltip>
      )
    },
    {
      Header: "Icon",
      accessor: "icon",
      Cell: ({ value }) => <i className="material-icons">{value}</i>,
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <Button size="small" sx={{ backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }} variant="contained" onClick={() => {
          setFormState({ title: row.original.title, description: row.original.description, icon: row.original.icon });
          setEditId(row.original.id);
          setIsEditingHeading(false);
          setTab(1);
        }}>
          Edit
        </Button>
      ),
    },
  ];

  const rows = items.map(item => ({
    ...item,
    actions: "",
  }));

  // const handleSave = () => {
  //   setFormLoading(true);
  //   // simulate save API or local update
  //   if (editId) {
  //     setItems(prev => prev.map(it => it.id === editId ? { ...formState, id: editId } : it));
  //   } else {
  //     const nextId = items.length + 1;
  //     setItems(prev => [...prev, { ...formState, id: nextId }]);
  //   }
  //   setFormState({ title: "", description: "", icon: "" });
  //   setEditId(null);
  //   setTab(0);
  //   setFormLoading(false);
  // };


  const handleSave = async () => {
    setFormLoading(true);

    try {
      const endpoint = editId
        ? `${url}auth/update-platform-feature/${editId}`
        : `${url}auth/create-platform-feature`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formState),
      });

      if (!response.ok) throw new Error("Errore durante il salvataggio");

      await fetchPlatformFeatures(); // Refresh list
      setFormState({ title: "", description: "", icon: "" });
      setEditId(null);
      setTab(0);
    } catch (err) {
      console.error("Save error:", err.message);
      alert("Errore nel salvataggio della funzionalità");
    } finally {
      setFormLoading(false);
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="#183759" borderRadius="lg" >
                <MDTypography variant="h6" color="white">Platform Features</MDTypography>
              </MDBox>

              {/* Platform Heading Section: Editable */}
              <MDBox pt={3} mb={3} px={2}>
                <Grid container>
                  <Grid item xs={12} sm={8} md={6}>
                    <Grid container alignItems="center">
                      {/* Left: Heading */}

                      {
                        !isEditingHeading &&
                        (
                          <>

                            <Grid item xs={4} >
                              <MDTypography
                                variant="h5"
                                sx={{
                                  fontWeight: 'bold',
                                  color: "#183759",  // Adjust text color
                                  fontSize: "24px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {platformHeading}
                              </MDTypography>
                            </Grid>

                          </>
                        )
                      }


                      {/* Right: Edit Icon or Button */}

                      {
                        !isEditingHeading && (
                          <>
                            <Grid item xs={4}>
                              <Button
                                variant="outlined"
                                onClick={handleEditHeading}
                                sx={{
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                  padding: "0",
                                  minWidth: "auto",
                                  // backgroundColor: "#f1f1f1",
                                  color: "#183759",
                                  "&:hover": {
                                    backgroundColor: "#f1f1f1", // Keep the background color same on hover
                                    border: "1px solid #183759",  // Keep the border color the same on hover
                                  },
                                  border: "1px solid #183759",  // Ensure border color stays consistent
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Edit sx={{ fontSize: 16 }} />  {/* Material-UI Edit Icon */}
                              </Button>
                            </Grid>

                          </>
                        )
                      }


                    </Grid>

                    {/* Edit Mode */}
                    {isEditingHeading && (
                      <>
                        <TextField
                          label="Edit Platform Heading"
                          fullWidth
                          value={platformHeading}
                          onChange={(e) => setPlatformHeading(e.target.value)}
                          sx={{ mb: 2 }}
                        />
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={handleSaveHeading}
                              sx={{
                                backgroundColor: "#183759",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#204b80" },
                              }}
                            >
                              Save Heading
                            </Button>
                          </Grid>
                          <Grid item xs={6}>
                            <Button
                              variant="outlined"
                              fullWidth
                              onClick={handleCancelEdit}
                              sx={{
                                backgroundColor: "#f1f1f1",
                                color: "#183759",
                                border: "1px solid #183759",  // Ensure border color stays consistent
                                "&:hover": {
                                  backgroundColor: "#f1f1f1", // Keep the background color same on hover
                                  border: "1px solid #183759",  // Keep the border color the same on hover
                                },
                              }}
                            >
                              Cancel
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </MDBox>

              <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="fullWidth">
                <Tab label="List" />
                {/* <Tab label={editId ? "Edit Feature" : ""} /> */}
                {editId && <Tab label="Edit Feature" />}
              </Tabs>

              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable table={{ columns, rows }} isSorted={false} entriesPerPage={{ defaultValue: 5 }} showTotalEntries={false} noEndBorder currentPageIndex={currentPageIndex} setCurrentPageIndex={setCurrentPageIndex} />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <TextField label="Title" fullWidth value={formState.title} onChange={e => setFormState({ ...formState, title: e.target.value })} sx={{ mb: 2 }} />
                      <TextField label="Description" fullWidth multiline value={formState.description} onChange={e => setFormState({ ...formState, description: e.target.value })} sx={{ mb: 2 }} />

                      {/* <TextField label="Icon Name" fullWidth value={formState.icon} onChange={e => setFormState({...formState, icon: e.target.value})} sx={{mb:2}} /> */}

                      <Autocomplete
                        options={iconOptions}
                        value={formState.icon}
                        onChange={(event, newValue) => setFormState({ ...formState, icon: newValue })}
                        renderInput={(params) => (
                          <TextField {...params} label="Icon" variant="outlined" sx={{ mb: 2 }} />
                        )}
                        renderOption={(props, option) => (
                          <Box component="li" {...props}>
                            <i className="material-icons" style={{ marginRight: 8 }}>{option}</i>
                            {option}
                          </Box>
                        )}
                      />

                      <Button onClick={handleSave} variant="contained" fullWidth sx={{ mb: 5, backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}>
                        {editId ? "Update" : "Save"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default PlatformFeatureDashboard;
